import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  TextField,
  Button,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  ListItemText,
  InputLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CustomTextField from "../Utils/CustomTextfield";
import {
  addSuperBillByProvider,
  deleteSuperBill,
  getAllFacility,
  getAllFacilityTypes,
  getAllStateMasters,
  getAllVisitReasons,
  getDxCode,
  getFacilityByProviderId,
  getFacilityTypeByProviderId,
  getPatientByProviderId,
  getSuperBillByProvider,
  submitForAuthorization,
  updateSuperBillByProvider,
} from "../api/action";
import { useDispatch, useSelector } from "react-redux";
import CustomSnackbar from "../Utils/CustomSnackbar";
import CustomPagination from "../Utils/CustomPagination";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import allDxCodes from "../Data/DXCode";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import CustomTable from "./CustomTable";
import BackdropLoader from "../Utils/Loader";
import ErrorModal from "./ErrorModal";
import { sanitizeInput } from "../Utils/validationSecurity";

const PatientFormTable = () => {
  // const initialRowState = {
  //   firstName: '',
  //   lastName: '',
  //   dob: dayjs().format('MM/DD/YYYY'),
  //   cptCode: null,
  //   dx_code: [],
  //   admission: '',
  //   modifier: '',
  //   reason: '',
  //   comment: ''
  // };
  // const initialState = Array.from({ length: 5 }, () => ({ ...initialRowState }));

  // const [state, setState] = useState(initialState);
  const [formData, setFormData] = useState({});
  const [tableRows, setTableRows] = useState([]);
  const [loading, setLoading] = useState(true);
   const [provider, setProvider] = useState( useSelector((state) => state?.user?.userName));
  const [providerId, setProviderId] = useState( useSelector((state) => state?.user?.userId));
  const [profileId, setProfileId] = useState( useSelector((state) => state?.user?.profileId));
  const [allFacilities, setAllFacilities] = useState([]);
  const [allFacilityType, setAllFacilityType] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allCpt, setAllCpt] = useState([]);
  const [allPatient, setAllPatient] = useState([]);
  // const [facility, setFacility] = useState(null);
  const [facilityType, setFacilityType] = useState("");
  const [facilityTypeId, setFacilityTypeId] = useState("");
  const [state, setState] = useState(null);
  const [superbillForm, setSuperbillForm] = useState(null);

  const [stateId, setStateId] = useState("");
  const [cpt, setCpt] = useState(null);
  const [dob, setDob] = useState(dayjs());
  const [dos, setDos] = useState(null);
  const [fName, setFName] = useState("");
  const [lName, setLName] = useState("");
  const [admission, setAdmission] = useState("");
  const [reason, setReason] = useState(null);
  const [comment, setComment] = useState("");
  const [modifier, setModifier] = useState("");
  const [dx, setDx] = useState([]);
  const [id, setId] = useState([]);
  const [superBillData, setSuperBillData] = useState([]);
  const [updated, setUpdated] = useState(false);
  const [updatedData, setUpdatedData] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [filteredData, setFilteredData] = useState();
  const [dxCode, setDxCode] = useState([]);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [dublicateData, setDublicateData] = useState([]);
  const [dublicateDataMessage, setDublicateDataMessage] = useState("");
  const [copyData, setCopyData] = useState([]);
  const [facility, setFacility] = useState(null);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const ROWS_PER_PAGE = 10;

  const initialRowState = {
    provider_profile: profileId|| "",
    facility_master: facility?.id,
    patient_name: "",
    last_name: "",
    dob: null,
    // dob: formatDate((dayjs())),
    date_of_service: null,
    cpt_code: [],
    dx_code: [],
    admission: "",
    reason_for_visit: "",
    comment: "",
    modifier: "",
    state: "",
    facility_type: facility?.facility_type_id,
  };

  function formatDate(date) {
    return dayjs(date).format("YYYY-MM-DD");
  }

  useEffect(() => {
    // setLoading(true);
    const payload = null;
    dispatch(
      getFacilityByProviderId(
        payload,
        providerId,
        (data) => {
          // setLoading(false);
          setAllFacilities(data?.data?.Data);
        },
        (error) => {
          console.log(error);
          // setLoading(false);
        }
      )
    );
  }, []);

  useEffect(() => {
    // setLoading(true);
    const payload = null;
    dispatch(
      getAllStateMasters(
        payload,
        (data) => {
          // setLoading(false);
          setAllState(data?.data?.Data);
        },
        (error) => {
          console.log(error);
          // setLoading(false);
        }
      )
    );
  }, []);

  useEffect(() => {
    // setLoading(true);
    const payload = null;
    dispatch(
      getAllVisitReasons(
        payload,
        (data) => {
          // setLoading(false);
          setAllCpt(data?.data?.Data);
        },
        (error) => {
          console.log(error);
          // setLoading(false);
        }
      )
    );
  }, []);

  useEffect(() => {
    // setLoading(true);
    const payload = null;
    dispatch(
      getPatientByProviderId(
        payload,
        profileId,
        (data) => {
          // setLoading(false);
          setAllPatient(data.data);
        },
        (error) => {
          console.log(error);
          // setLoading(false);
        }
      )
    );
  }, []);

  useEffect(() => {
    setLoading(true);
    const payload = null;
    dispatch(
      getSuperBillByProvider(
        payload,
        profileId,
        (data) => {
          setLoading(false);
          setSuperBillData(data?.data);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, [updatedData, updated]);

  const handleCheckboxChange = (id) => {
    const isSelected = selectedRows.includes(id);
    setSelectedRows((prevSelected) =>
      isSelected
        ? prevSelected.filter((code) => code !== id)
        : [...prevSelected, id]
    );

    // Set the selected row id in the id state
    setId((prevIds) =>
      isSelected ? prevIds.filter((code) => code !== id) : [...prevIds, id]
    );
  };

  useEffect(() => {
    const initialRows = Array.from({ length: 1 }, (_, index) => ({
      id: index + 1,
      formData: {},
      dob: "",
      provider: "",
      facility: "",
      facilityType: "",
      state: "",
      dateOfService: null,
      cptCode: "",
      dxCode: "",
      admission: "",
      reasonForVisit: "",
      comment: "",
      modifier: "",
    }));
    setTableRows(initialRows);
  }, []);

  // useEffect(() => {
  //   setFilteredData(state?.filter(item => item.patient_name && item.last_name))
  // }, [state]);

  function formatData(arr) {
    // console.log(arr, "abc")
    const sortedArr = arr.sort((a, b) => b.localeCompare(a));
    return sortedArr.join(", ");
  }

  const handleAddTimeSheet = (e) => {
    e.preventDefault();

    // Filter out rows without patient_name and last_name
    const filteredData = state.filter(
      (item) => item.patient_name && item.last_name
    );
    // Check if any item has an empty facility_master
    if (filteredData?.some((item) => !item.facility_master)) {
      const errorMessage = "Please select the facility";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }


    // Check if any mandatory field is empty
    if (
      filteredData?.some(
        (item) =>
          !item?.patient_name ||
          !item?.last_name ||
          item?.dx_code?.length === 0 || item?.dx_code === null ||
          item?.cpt_code?.length === 0 || item?.cpt_code === null ||
          !item?.dob || !dos || item?.dob === "Invalid Date"
      )
    ) {
      const errorMessage = "Please fill the mandatory fields";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const sanitizedData = filteredData.map((item) => ({
      ...item,
      patient_name: sanitizeInput(item.patient_name),
      last_name: sanitizeInput(item.last_name),
      modifier: sanitizeInput(item.modifier),
      comment: sanitizeInput(item.comment),
    }));

   let lastValidDate = null;

const updatedState = sanitizedData.map((item) => {
  let currentDOS = item.date_of_service
    ? formatDate(item.date_of_service)
    : null;

  // If current row has date, update lastValidDate
  if (currentDOS) {
    lastValidDate = currentDOS;
  } else if (lastValidDate) {
    // If missing, use the previously stored valid date
    currentDOS = lastValidDate;
  }

  return {
    ...item,
    dob: formatDate(item.dob),
    dx_code: formatData(item.dx_code),
    date_of_service: currentDOS,

    facility_type:
      item.facility_type && typeof item.facility_type === "object"
        ? item.facility_type.id
        : item.facility_type,

    facility_master:
      item.facility_master && typeof item.facility_master === "object"
        ? item.facility_master.id
        : item.facility_master,
  };
});



    const payload = updatedState;

    setLoading(true);
    dispatch(
      addSuperBillByProvider(
        payload,
        (data) => {
          setLoading(false);
          setSelectAll(false);
          setSelectedRows([]);
          setCopyData([]);
          setUpdated((prevState) => !prevState);
          setSnackbarMessage("Super Bill added successfully");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
          // setSuperbillForm(null);
          const emptyRows = Array.from({ length: 5 }, () => ({
            ...initialRowState,
          }));
          setState([
            {
              provider_profile: profileId,
              facility_master: facility.id || "",
              facility_type: state[0]?.facility_type || facilityTypeId || "",
              date_of_service: null,
              dob: state[0]?.dob || "",
              patient_name: "",
              last_name: "",
              dx_code: [],
              cpt_code: [],
              admission: "",
              modifier: "",
              reason_for_visit: "",
              comment: "",
              state: "",
            },
          ]);
          setDos(null)
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.msg ||
              "Oops! Looks like we need you to log in again to keep things secure!";

          setSnackbarMessage(errorMessage);
          setDublicateData(error.response?.data?.data);
          setDublicateDataMessage(error.response?.data?.msg);
          setErrorModalOpen(true);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  const initialState =
    Array.isArray(copyData) && copyData?.length > 0
      ? copyData?.map((item) => ({
        provider_profile: profileId,
        facility_master: facility?.id,
        patient_name: item.patient_name,
        last_name: item.last_name,
        dob: item.dob,
        date_of_service: null,
        cpt_code: item.cpt_code,
        dx_code: item.dx_code,
        admission: item.admission,
        reason_for_visit: item.reason_for_visit,
        comment: item.comment,
        modifier: item.modifier,
        state: "",
        facility_type: facilityTypeId,
      }))
      : Array.from({ length: 5 }, () => ({ ...initialRowState }));

  useEffect(() => {
    setState(initialState);
  }, [updated, copyData]);

  const handleDelete = (e) => {
    e.preventDefault();

    const payload = {
      super_biller_id: selectedRows,
    };

    setLoading(true);
    dispatch(
      deleteSuperBill(
        payload,
        (data) => {
          setLoading(false);
          setUpdatedData((prevState) => !prevState);
          setSnackbarMessage("Super Bill Deleted successfully");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
          setSelectedRows([]);
          // setDos(null)
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.detail ||
              "Oops! Looks like we need you to log in again to keep things secure!";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  function getCurrentDateTime() {
    const now = new Date();

    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const year = String(now.getFullYear()).slice(-2);
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  }

  const handleAuthorization = (e) => {
    e.preventDefault();

    if (id.length === 0) {
      setSnackbarMessage("Please select at least one data");
      setSnackbarOpen(true);
      setSnackbarSeverity("error");
    }

    const payload = {
      user_id: id,
      provider_id: providerId,
      datetime: getCurrentDateTime(),
    };

    setLoading(true);
    dispatch(
      submitForAuthorization(
        payload,
        (data) => {
          setLoading(false);
          setUpdated((prevState) => !prevState);
          setSelectAll(false);

          setSnackbarMessage("Submitted for Billing successfully");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.error ||
              "Oops! Looks like we need you to log in again to keep things secure!";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleSelectAllChange = (event) => {
    setSelectAll(event.target.checked);
    if (event.target.checked) {
      const allCodes = superBillData.map((row) => row.id);
      setSelectedRows(allCodes);
      // Set all rows id in id state
      setId(allCodes);
    } else {
      setSelectedRows([]);
      setId([]);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
  const endIndex = startIndex + ROWS_PER_PAGE;

  // function to close modal
  const handleModalClose = () => {
    setErrorModalOpen(false);
    setDublicateData([]); // optional: clear errors when modal closes
  };

  return (
    <form id="patientFormTable" onSubmit={handleSubmit} autoComplete="off">
      <Box sx={{ px: { md: 3, xs: 2 } }}>
        <Box>
          <Typography
            variant="h6"
            sx={{ color: "rgba(29, 57, 105, 1)", fontWeight: "bold" }}
          >
            Super Bill
          </Typography>
          <CustomTable
            state={state}
            setState={setState}
            facility={facility}
            dos={dos}
            setDos={setDos}
            handleAddTimeSheet={handleAddTimeSheet}
            updated={updated}
            copyData={copyData}
            setCopyData={setCopyData}
            initialRowState={initialRowState}
            // facility={facility}
            setFacility={setFacility}
          />
        </Box>

        <ErrorModal
          open={errorModalOpen}
          data={dublicateData}
          onClose={handleModalClose}
          msg={dublicateDataMessage}
        />

        {/* <Box sx={{ display: 'flex', float: 'right', my: 5 }}>

          <Button className='buttonPadding' type="submit" variant="contained" sx={{ background: 'rgba(29, 57, 105, 1) !important', px: 3, mx: 1 }} onClick={handleAddTimeSheet}>
            Save
          </Button>


        </Box> */}

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 20 }}>
            <CircularProgress />
          </Box>
        ) : (
          superBillData.length !== 0 && (
            <Box sx={{ my: 4 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: "rgba(29, 57, 105, 1)",
                    fontWeight: "bold",
                    mb: 3,
                  }}
                >
                  Saved Data
                </Typography>
              </Box>

              <TableContainer className="scrollBar" component={Paper}>
                <Table>
                  <TableHead sx={{ background: "rgba(29, 57, 105, 1)", py: 0 }}>
                    <TableRow>
                      <TableCell sx={{ color: "#fff", py: 0.2 }}>
                        <Checkbox
                          checked={selectAll}
                          onChange={handleSelectAllChange}
                          style={{ color: "#fff" }}
                        />
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        Provider
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        Facility
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        Facility Type
                      </TableCell>
                      {/* <TableCell sx={{ color: "#fff", py: 0, whiteSpace: 'nowrap', }}>State</TableCell> */}
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        First Name
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        Last Name
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        Date of Birth
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        Date of Service
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        CPT Code
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        DX Code
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        Admission
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        Modifier
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        Reason for Visit
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                      >
                        Comment
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[...superBillData]
                      .slice(startIndex, endIndex)
                      .map((row) => (
                        <TableRow key={row.id}>
                          <TableCell sx={{ py: 0.5 }}>
                            <Checkbox
                              size="small"
                              checked={selectedRows.includes(row.id)}
                              onChange={() => handleCheckboxChange(row.id)}
                              style={{ color: "rgba(29, 57, 105, 1)" }}
                            />
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.provider_profile?.First_Name +
                              " " +
                              row.provider_profile?.Last_Name}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.facility_master?.facility_name}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.facility_type?.facility_type_Name}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.patient_name}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.last_name}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.dob}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.date_of_service}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.cpt_code}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.dx_code}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.admission}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.modifier}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.reason_for_visit}
                          </TableCell>
                          <TableCell
                            className="fs12"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {row?.comment}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <CustomPagination
                count={Math.ceil(superBillData.length / ROWS_PER_PAGE)}
                page={currentPage}
                onChange={handleChangePage}
              />

              <Box
                sx={{ display: "flex", my: 5, justifyContent: "space-between" }}
              >
                <Button
                  disabled={selectedRows.length === 0}
                  onClick={handleDelete}
                  className="buttonPadding"
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor:
                      selectedRows.length === 0
                        ? "#d3d3d3"
                        : "rgba(29, 57, 105, 1)",
                    px: 3,
                    mb: 3,
                    "&:hover": {
                      backgroundColor:
                        selectedRows.length === 0
                          ? "#d3d3d3"
                          : "rgba(29, 57, 105, 1)",
                    },
                  }}
                >
                  Delete
                </Button>
                <Button
                  className="buttonPadding"
                  disabled={
                    selectedRows.length === 0 ||
                    state?.some(
                      (row) =>
                        row.patient_name && row.patient_name.trim() !== ""
                    )
                  }
                  type="submit"
                  variant="contained"
                  sx={{
                    background: selectedRows.length === 0 ? "#d3d3d3" : null,
                    px: 3,
                    mx: 1,
                    mb: 3,
                  }}
                  onClick={handleAuthorization}
                >
                  Submit for Billing
                </Button>
              </Box>
            </Box>
          )
        )}

        <CustomSnackbar
          open={snackbarOpen}
          handleClose={handleSnackbarClose}
          message={snackbarMessage}
          severity={snackbarSeverity}
        />
      </Box>
    </form>
  );
};

export default PatientFormTable;
